import React, { Component } from "react";
import { connect } from "react-redux";
import { every, some } from "lodash";
import { parse } from "qs";
import moment from "moment";
import ListPage from "../components/list-page/index";
import { updateFilterConditions, fetchTasks, fetchInitData, changePage } from "./redux/action";
import {message} from "antd";
import {UPLOAD_TYPE_ALL} from "../../consts/uploadtypes";

const QUERY_FIELDS = ["deviceId", "appId", "appVersion", "diagnosisId", "descriptionKeyword", "uploadType", "platform", "beginTime", "endTime"];

// 两组查询条件是否等价（用于判断是否是从详情页原样返回）
function isSameQuery(a, b) {
  if (!a || !b) {
    return false;
  }
  return every(QUERY_FIELDS, key => String(a[key] === void 0 || a[key] === null ? "" : a[key]) === String(b[key] === void 0 || b[key] === null ? "" : b[key]));
}


export class NativeList extends Component {

  componentDidCatch(error, errorInfo) {
    message.error("页面异常！");
    this.props.history.replace("/");
  }

  componentDidMount() {
    const { updateFilterConditions, fetchTasks, fetchInitData, changePage, query, pagination } = this.props;

    let params = {};
    if (this.props.location) {
      params = parse(this.props.location.search, { ignoreQueryPrefix: true });
    }
    
    const { deviceId, appId, appVersion, diagnosisId, descriptionKeyword, uploadType, platform, beginTime, endTime } = params;
    
    if (some([deviceId, beginTime, endTime, platform], item => item === void 0) && !every([deviceId, beginTime, endTime, platform], item => item === void 0)) {
      message.warn("url参数错误！获取默认日志列表");
    }

    if (deviceId !== void 0 && beginTime && endTime && platform !== void 0) {
      const conditions = {
        deviceId,
        appId: appId !== void 0 ? appId : "",
        appVersion: appVersion !== void 0 ? appVersion : "",
        diagnosisId: diagnosisId !== void 0 ? diagnosisId : "",
        descriptionKeyword: descriptionKeyword !== void 0 ? descriptionKeyword : "",
        uploadType: uploadType !== void 0 && uploadType !== "" ? Number.parseInt(uploadType) : UPLOAD_TYPE_ALL,
        platform: Number.parseInt(platform),
        beginTime: moment(Number.parseInt(beginTime)).valueOf(),
        endTime: moment(Number.parseInt(endTime)).valueOf()
      };
      updateFilterConditions(conditions);
      if (isSameQuery(conditions, query)) {
        // 从详情页「返回列表」回来，条件没变：停留在原来的页码，只刷新数据
        changePage(pagination.pageNum, pagination.pageSize);
      } else {
        fetchTasks(conditions);
      }
    } else if (query) {
      // 浏览器后退等无参数进入，但本次会话已经查过：沿用上次的条件和页码
      changePage(pagination.pageNum, pagination.pageSize);
    } else {
      updateFilterConditions({
        deviceId: "",
        appId: "",
        appVersion: "",
        diagnosisId: "",
        descriptionKeyword: "",
        uploadType: UPLOAD_TYPE_ALL,
        platform: 0,
        beginTime: moment().startOf("day").subtract(6, 'days').valueOf(),
        endTime: moment().startOf("day").valueOf()
      });
      fetchInitData();
    }

  }  

  render() {
    return (
      <ListPage
        {...this.props}
        data-test="ListPage"
        type="native"
        detailUrlPrefix="/native-log-detail"
        onPageChange={this.props.changePage}
      />
    )
  }
}

export function mapStateToProps(state) {
  return {
    ...state.nativeList
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    updateFilterConditions: newFilterConditions => dispatch(updateFilterConditions(newFilterConditions)),
    fetchTasks: (filterConditions) => dispatch(fetchTasks(filterConditions)),
    fetchInitData: () => dispatch(fetchInitData()),
    changePage: (pageNum, pageSize) => dispatch(changePage(pageNum, pageSize))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NativeList);
